import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Main = styled.div`
  min-height: 46px;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  background-color: ${ColorSF2.paleBlue};
  padding: 0 10px;
  margin-top: 1px;
  @media (max-height: 530px) {
    font-size: 12px;
  }
`;
export const InputWrapper = styled.div`
  margin: 10px 0;
`;
export const Input = styled.input`
  height: 30px;
  margin-left: 10px;
  width: 200px;
  border: 1px solid ${ColorSF2.mediumGray};
  border-radius: 4px;
  @media (max-height: 530px) {
    font-size: 12px;
  }
`;
export const Select = styled.select`
  height: 30px;
  margin-left: 10px;
  border: 1px solid ${ColorSF2.mediumGray};
  border-radius: 4px;
  @media (max-height: 530px) {
    font-size: 12px;
  }
`;
export const SearchBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex: 0 0 auto;
  flex-wrap: wrap;
`;
